import { BMPrimitives, BMText, useBMTheme } from "@traveloka/district-bloom";
import { BMTextInk } from "@traveloka/district-bloom/js/components/Text/BMText";
import { useMemo } from "react";
import { StyleSheet } from "react-native";
import BMView from "../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";

type Props =
  | {
      variant: "REFUND";
      status: "REFUNDABLE" | "PARTIAL_REFUNDABLE" | "NON_REFUNDABLE";
    }
  | {
      variant: "RESCHEDULE";
      status: "RESCHEDULABLE" | "PARTIAL_RESCHEDULABLE" | "NON_RESCHEDULABLE";
    };

export default function FlightRefundRescheduleBadge({ status }: Props) {
  const { BMComponents } = useBMTheme();
  const { content, ink, color } = useCreateRefundRescheduleBadgeToken(status);
  return (
    <BMView
      style={[
        styles.container,
        {
          borderColor: BMComponents[color],
        },
      ]}
    >
      <BMText variant="uiSmall" ink={ink}>
        {content}
      </BMText>
    </BMView>
  );
}

type BadgeTokens = {
  ink: BMTextInk;
  color: BMTextInk;
  content: string;
};

/**
 * Custom hook to create badge token based on props
 */
function useCreateRefundRescheduleBadgeToken(status: Props["status"]) {
  const { CorporateFlightRefundRescheduleEnum: cre } =
    useMobileContentResource();
  return useMemo((): BadgeTokens => {
    const content = cre[status];
    let ink: BMTextInk = "BMStyleTextInkSecondary";
    let color: BMTextInk = "BMStyleLineBordercolorSubtle";

    if (status === "REFUNDABLE" || status === "RESCHEDULABLE") {
      ink = "BMStyleIconInkHighlightGreen";
      color = "BMStyleLineBordercolorFocus";
    } else if (
      status === "PARTIAL_REFUNDABLE" ||
      status === "PARTIAL_RESCHEDULABLE"
    ) {
      ink = "BMStyleTextInkPrimary";
    }

    return { ink, color, content };
  }, [status, cre]);
}

const styles = StyleSheet.create({
  container: {
    paddingVertical: BMPrimitives.BMSize.xs,
    paddingHorizontal: BMPrimitives.BMSize.sm,
    borderWidth: BMPrimitives.BMBorder.width.thick,
    borderRadius: BMPrimitives.BMBorder.radius.rounded,
  },
});
